function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDebit = function SvgDebit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "591pt",
    viewBox: "0 0 591.60405 591",
    width: "591pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 555.878906 168.519531 L 449.105469 61.542969 L 449.105469 490.230469 L 592 490.230469 L 592 255.378906 C 592 222.769531 578.996094 191.507812 555.878906 168.519531 Z M 555.878906 168.519531 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,71.764706%,50.980392%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.457031 412.117188 L 2.738281 202.570312 C -5.363281 181.535156 5.117188 157.90625 26.164062 149.800781 L 407.15625 3.046875 C 428.191406 -5.054688 451.820312 5.425781 459.921875 26.472656 L 540.640625 236.019531 C 548.742188 257.054688 538.261719 280.683594 517.214844 288.789062 L 136.234375 435.542969 C 115.1875 443.644531 91.570312 433.152344 83.457031 412.117188 Z M 83.457031 412.117188 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.058824%,29.803922%,23.529412%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 489.011719 101.960938 L 32.195312 279.03125 L 62.613281 357.992188 L 519.449219 181.003906 Z M 489.011719 101.960938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,28.627451%,18.823529%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.00390625 265.679688 L 0.00390625 41.128906 C 0.00390625 18.582031 18.285156 0.300781 40.832031 0.300781 L 449.105469 0.300781 C 471.652344 0.300781 489.933594 18.582031 489.933594 41.128906 L 489.933594 265.679688 C 489.933594 288.226562 471.652344 306.507812 449.105469 306.507812 L 40.832031 306.507812 C 18.285156 306.507812 0.00390625 288.226562 0.00390625 265.679688 Z M 0.00390625 265.679688 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(26.27451%,59.607843%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449.105469 0.300781 L 405.726562 0.300781 L 99.519531 306.507812 L 449.105469 306.507812 C 471.652344 306.507812 489.933594 288.226562 489.933594 265.679688 L 489.933594 41.128906 C 489.933594 18.582031 471.652344 0.300781 449.105469 0.300781 Z M 449.105469 0.300781 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.313725%,54.901961%,78.039216%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.832031 163.609375 L 81.660156 163.609375 L 81.660156 184.023438 L 40.832031 184.023438 Z M 40.832031 163.609375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.832031 224.851562 L 81.660156 224.851562 L 81.660156 245.265625 L 40.832031 245.265625 Z M 40.832031 224.851562 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 224.554688 224.851562 L 265.382812 224.851562 L 265.382812 245.265625 L 224.554688 245.265625 Z M 224.554688 224.851562 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102.074219 163.609375 L 142.898438 163.609375 L 142.898438 184.023438 L 102.074219 184.023438 Z M 102.074219 163.609375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163.3125 163.609375 L 204.140625 163.609375 L 204.140625 184.023438 L 163.3125 184.023438 Z M 163.3125 163.609375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 224.554688 163.609375 L 265.382812 163.609375 L 265.382812 184.023438 L 224.554688 184.023438 Z M 224.554688 163.609375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 418.484375 41.128906 L 438.898438 41.128906 L 438.898438 71.75 L 418.484375 71.75 Z M 418.484375 41.128906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.65625 41.128906 L 398.070312 41.128906 L 398.070312 71.75 L 377.65625 71.75 Z M 377.65625 41.128906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.828125 41.128906 L 357.242188 41.128906 L 357.242188 71.75 L 336.828125 71.75 Z M 336.828125 41.128906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 296.003906 41.128906 L 316.414062 41.128906 L 316.414062 71.75 L 296.003906 71.75 Z M 296.003906 41.128906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,70.196078%,81.960784%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.277344 490.230469 L 592 490.230469 L 592 592.296875 L 408.277344 592.296875 Z M 408.277344 490.230469 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(53.333333%,70.196078%,21.568627%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 378.320312 184.6875 C 361.007812 167.4375 332.992188 167.488281 315.742188 184.800781 C 299.0625 201.539062 298.484375 228.433594 314.425781 245.878906 L 398.070312 337.128906 C 372.929688 381.128906 374.003906 435.386719 400.855469 478.359375 L 408.277344 490.230469 L 540.964844 490.230469 L 540.964844 347.335938 Z M 378.320312 184.6875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,71.764706%,50.980392%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 438.898438 520.851562 L 459.3125 520.851562 L 459.3125 541.265625 L 438.898438 541.265625 Z M 438.898438 520.851562 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(41.960784%,58.823529%,16.470588%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.832031 106.453125 L 40.832031 57.460938 C 40.832031 48.4375 48.140625 41.128906 57.164062 41.128906 L 106.15625 41.128906 C 115.179688 41.128906 122.484375 48.4375 122.484375 57.460938 L 122.484375 106.453125 C 122.484375 115.476562 115.179688 122.785156 106.15625 122.785156 L 57.164062 122.785156 C 48.140625 122.785156 40.832031 115.476562 40.832031 106.453125 Z M 40.832031 106.453125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,71.372549%,18.431373%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.832031 71.75 L 71.453125 71.75 L 71.453125 92.164062 L 40.832031 92.164062 Z M 40.832031 71.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,48.235294%,18.431373%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91.867188 71.75 L 122.484375 71.75 L 122.484375 92.164062 L 91.867188 92.164062 Z M 91.867188 71.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,48.235294%,18.431373%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 530.757812 347.335938 C 528.054688 347.335938 525.453125 346.261719 523.542969 344.34375 L 482.714844 303.515625 C 478.796875 299.464844 478.910156 293.003906 482.972656 289.082031 C 486.933594 285.265625 493.199219 285.265625 497.148438 289.082031 L 537.976562 329.910156 C 541.957031 333.902344 541.957031 340.363281 537.976562 344.34375 C 536.054688 346.261719 533.464844 347.335938 530.757812 347.335938 Z M 530.757812 347.335938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,64.313725%,43.529412%)",
      fillOpacity: 1
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDebit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/debit.e96cf6d0.svg";
export { ForwardRef as ReactComponent };